<ng-container *ngIf="ready">
    <div class="flex-container">
        <div class="one-column">
            <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true"
                [actionsTemplate]="actionsButtons">
            </app-table>
        </div>
    </div>
    <ng-container *ngIf="empty">
        <div class="text-center">
            <img src="assets/icons/contacto.svg" class="invoiceImage">
            <p style="color: #9e9e9e">No ha realizado ningún pago a Handly.</p>
        </div>
    </ng-container>

    <ng-template #actionsButtons let-uid="uid">
        <ul class="custom-class">
            <li (click)="pdf(uid)">
                <a>
                    <mat-icon>dvr</mat-icon>PDF
                </a>
            </li>
        </ul>
    </ng-template>
</ng-container>
